import {
  createPortalRenderFailureReport,
  reportPortalRenderFailure,
  type PortalRenderFailureInput,
  type PortalRenderFailureReporter,
} from "./route-error-model";

let registeredReporter: PortalRenderFailureReporter | null = null;

export function registerPortalRenderFailureReporter(
  reporter: PortalRenderFailureReporter,
) {
  registeredReporter = reporter;

  return () => {
    if (registeredReporter === reporter) {
      registeredReporter = null;
    }
  };
}

export function publishPortalRenderFailure(
  input: PortalRenderFailureInput,
  reporter: PortalRenderFailureReporter | null = registeredReporter,
) {
  return reportPortalRenderFailure(
    reporter,
    createPortalRenderFailureReport(input),
  );
}
